// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"34f94b72","239":"53f2724f","455":"3d6dafe5"}[chunkId] + ".chunk.js";
};